import { render, staticRenderFns } from "./FabricAdditionalDetail.vue?vue&type=template&id=b51d1b38&scoped=true"
import script from "./FabricAdditionalDetail.vue?vue&type=script&lang=js"
export * from "./FabricAdditionalDetail.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./FabricAdditionalDetail.vue?vue&type=style&index=1&id=b51d1b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51d1b38",
  null
  
)

export default component.exports